function handleCustomRF(){
  $('#RegisterForm .btn[type="submit"]').val("Submit");
    var wrapper = $('<div class="wrapper"></div>');
    const region = $(".formbuilder-text, .formbuilder-select").filter((ind, item) => {
        const label = $(item).find("label").text();
        return label.includes("City") || label.includes("State")
    });
    var region0 = region.eq(0);
    var region1 = region.eq(1);
    region0.after(wrapper)
    wrapper.append(region0);
    wrapper.append(region1);
    $('#container').append(wrapper);
    wrapper.css({
        'display': 'grid',
        'grid-template-columns': '1fr 1fr',
        'grid-gap': '20px'
    });
    var wrapper1 = $('<div class="wrapper"></div>');
    let region2 = $(".field").filter((ind, item) => {
        const label = $(item).find("label").text();
        return label.includes("First Name") || label.includes("Last Name")
    });
    var region3 = region2.eq(0);
    var region4 = region2.eq(1);
    region3.after(wrapper1)
    wrapper1.append(region3);
    wrapper1.append(region4);
    $('#container').append(wrapper1);
    wrapper1.css({
        'display': 'grid',
        'grid-template-columns': '1fr 1fr',
        'grid-gap': '20px'
    });
}
if(window.location.pathname === '/pages/customer-application-form') {
  var elapsed = 0;
  var intervalId = setInterval(function() {
      if ($('#bss-b2b-registration-form-render').length > 0) {
          handleCustomRF();
          clearInterval(intervalId);
      } else {
          elapsed += 100;
          if (elapsed >= 10000) {
              clearInterval(intervalId);
          }
      }
  }, 100);
}

function handleHideShowPrice(){
  if (!document.getElementById('hide-element-style')) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.id = 'hide-element-style';
    style.innerHTML = '[bss-b2b-cart-total-price], [bss-b2b-item-original-price], [bss-b2b-compare-price] { visibility: hidden !important }';
    document.head.appendChild(style);
    setTimeout(function() {
      var styleToRemove = document.getElementById('hide-element-style');
      if (styleToRemove) {
        document.head.removeChild(styleToRemove);
      }
    }, 4000);
  }
}

document.addEventListener("BSS_CP_Calculated", () => {
  setTimeout(() => {
    var styleToRemove = document.getElementById('hide-element-style');
      if (styleToRemove) {
        document.head.removeChild(styleToRemove);
      }
  }, 600)
});

document.addEventListener('bss-update-price', e=> {
  BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0, 0);
});

// function debounce(func, wait) {
//   let timeout;
//   return function(...args) {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => func.apply(this, args), wait);
//   };
// }

function handleCartDrawer() {
  // handleHideShowPrice();
  setTimeout(() => {
    BSS_B2B?.cart?.fixer(BSS_B2B.shopData, 0, 0);
  }, 300);
}

// const debouncedHandle = debounce(handleCartDrawer, 300);

document.addEventListener("open-cart-drawer", handleCartDrawer);
document.addEventListener("bss:update-cart", handleCartDrawer);

if (typeof BSS_B2B != undefined) {
    if (window.location.pathname.includes("/pages/upload-order")) {
        setTimeout(() => {
            const targetProduct = document.querySelector("#csv-output");
            if (targetProduct) {
                const mutationObserver = new MutationObserver((recordList, observe) => {
                    for (const record of recordList) {
                        if (record.target.id === "csv-output") {
                            BSS_B2B.cp.changeProductPrice(
                                JSON.parse($("#bss-b2b-store-data").html()),
                                false,
                                false,
                                true
                            );
                            break;
                        }
                    }
                });
                mutationObserver.observe(targetProduct, { childList: true, subtree: true });
            }
        }, 1000);
    }
}
if (typeof BSS_B2B != undefined) {
    if (window.location.pathname.includes("/pages/upload-order")) {
        setTimeout(() => {
            const targetProduct = document.querySelector("#result");
            if (targetProduct) {
                const mutationObserver = new MutationObserver((recordList, observe) => {
                    for (const record of recordList) {
                        if (record.target.id === "result") {
                            BSS_B2B.cp.changeProductPrice(
                                JSON.parse($("#bss-b2b-store-data").html()),
                                false,
                                false,
                                true
                            );
                            break;
                        }
                    }
                });
                mutationObserver.observe(targetProduct, { childList: true, subtree: true });
            }
        }, 1000);
    }
}

if (typeof BSS_B2B != undefined) {
    if (window.location.pathname.includes("/pages/upload-order")) {
        setTimeout(() => {
            const targetProduct = document.querySelector("#selectedProduct");
            if (targetProduct) {
                const mutationObserver = new MutationObserver((recordList, observe) => {
                    for (const record of recordList) {
                        if (record.target.id === "selectedProduct") {
                            BSS_B2B.cp.changeProductPrice(
                                JSON.parse($("#bss-b2b-store-data").html()),
                                false,
                                false,
                                true
                            );
                            break;
                        }
                    }
                });
                mutationObserver.observe(targetProduct, { childList: true, subtree: true });
            }
        }, 1000);
    }
}
if (typeof BSS_B2B != undefined) {
    if (window.location.pathname.includes("/pages/sku-lookup")) {
        setTimeout(() => {
            const targetProduct = document.querySelector("#resultTableBody");
            if (targetProduct) {
                const mutationObserver = new MutationObserver((recordList, observe) => {
                    for (const record of recordList) {
                        if (record.target.id === "resultTableBody") {
                            BSS_B2B.cp.changeProductPrice(
                                JSON.parse($("#bss-b2b-store-data").html()),
                                false,
                                false,
                                true
                            );
                            break;
                        }
                    }
                });
                mutationObserver.observe(targetProduct, { childList: true, subtree: true });
            }
        }, 1000);
    }
}
